// extracted by mini-css-extract-plugin
export default {"spinner":"spinner__paevy","__size-16":"__size-16__paevy","__size-32":"__size-32__paevy"};